import upperFirst from 'lodash/upperFirst'

import type { DomainNode } from '@app/types'
import { COLOR_MAP } from '@app/utils/iconMap'
export type CardSize = 'normal' | 'small' | 'large'
export type RegressionScoreType = string
export type RegressionScore = number | null

export interface CardMetadata {
  size: CardSize
  color?: string
  regressionScore: RegressionScore
  regressionScoreType: RegressionScoreType | null
}

const cardMetadata = (node: DomainNode): CardMetadata => {
  const domainObjectType = node?.type
  const size = (node?.metadata?.size || 'normal') as CardSize
  const sourceName = node?.data?.sourceName

  const defaultColor =
    sourceName === 'MetricSources::Calculated' ? COLOR_MAP.Calculated : COLOR_MAP[upperFirst(domainObjectType)]

  const color = node?.metadata?.color || defaultColor

  const regressionScore = node?.metadata?.regression_score as RegressionScore
  const regressionScoreType = node?.metadata?.regression_score_type as RegressionScoreType | null

  return { size, color, regressionScore, regressionScoreType }
}

export default cardMetadata
